import React from 'react';
import { Box, Typography, Grid, Link, Divider } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { PartnerResource } from '../../../interfaces/partnerResources.interface';

const MemberDiscounts = ({
  handleDownloadPartnerResource,
  filteredSections,
}: {
  filteredSections: PartnerResource[];
  handleDownloadPartnerResource: (section: PartnerResource) => void;
}) => {
  return (
    <Box sx={{ padding: 4, paddingRight: 0 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Exclusive TPN Member Discounts on Penetration Testing and Vulnerability Scanning
      </Typography>
      <Typography variant="body1" paragraph>
        To support our mission to strengthen content security across the industry, we’ve partnered
        with the following companies to offer group discounts on penetration testing and vulnerability
        scanning as defined in the MPA Content Security Best Practices TS-4.1 and TS-4.0, respectively.
      </Typography>
      <Typography variant="body1" paragraph>
        This discount is available to all paid active TPN members.
      </Typography>
      <Typography variant="body1" paragraph>
        Please contact the following companies directly to receive your discounted quote:
      </Typography>
      <Grid container spacing={4} mt={2}>
        {filteredSections.map((company, index) => {
          const logo = company?.images?.[0]?.image || null;
          const email = company?.subDescription || null;

          return (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  p: 3,
                  textAlign: 'center',
                  height: '100%',
                  border: '1px solid #eceef0',
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 3,
                  },
                }}
              >
                <Typography variant="h6" fontWeight={500} gutterBottom>
                  {company.title}
                </Typography>
                {logo ? (
                  <Box
                    component="img"
                    src={logo}
                    alt={`${company.title} logo`}
                    sx={{
                      maxWidth: '100%',
                      maxHeight: 50,
                      objectFit: 'contain',
                      mx: 'auto',
                      my: 2,
                    }}
                  />
                ) : (
                  <Typography variant="body2" color="textSecondary" mt={1}>
                    No logo available
                  </Typography>
                )}
                <Divider sx={{ my: 2 }} />
                {email ? (
                <Link
                onClick={() => handleDownloadPartnerResource(company)}
                href={`mailto:${email}`}
                aria-label={`Email ${company.title}`}
                variant="body2"
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1,
                  mt: 1,
                  fontSize: '0.85rem',
                  textAlign: 'left',
                  color: '#1976d2',
                  wordBreak: 'break-word',
                  justifyContent: 'center',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                <EmailIcon fontSize="small" sx={{ mt: '0px', color: '#1976d2' }} />
                {email}
              </Link>
                ) : (
                  <Typography variant="body2" color="textSecondary" mt={1}>
                    No email listed
                  </Typography>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default MemberDiscounts;
